import { Injectable } from '@angular/core';

import { Superpower } from '@bespunky/angular-google-maps/core';

@Injectable({providedIn: 'root'})
export class MockSuperpower1 extends Superpower { }
@Injectable({providedIn: 'root'})
export class MockSuperpower2 extends Superpower { }